import { Col, Layout, Row } from "antd";
import styles from "./Footer.module.css";

function Footer() {
  const { Footer: AntFooter } = Layout;
  const year = new Date().getFullYear();

  return (
    <AntFooter className={styles.footer}>
      <div className={styles.footerContent}>
        <span className={styles.copyrightText}>
          {year}{" "}
          <a
            href="https://softomation.com"
            className="font-weight-bold"
            target="_blank"
            rel="noreferrer"
          >
            Softomation Technologies
          </a>
        </span>
        <ul className={styles.footerList}>
          <li className="nav-item">
            <a href="/admin" className="nav-link text-muted" target="/">
              About Us
            </a>
          </li>
          <li className="nav-item">
            <a
              href="/privacy-policy/"
              className="nav-link text-muted"
              target="_blank"
            >
              Privacy Policy
            </a>
          </li>
          <li className="nav-item">
            <a
              href="/admin"
              className="nav-link pe-0 text-muted"
              target="_blank"
            >
              License
            </a>
          </li>
        </ul>
      </div>
    </AntFooter>
  );
}

export default Footer;
